import { render } from "./InspectionMenu.vue?vue&type=template&id=00bdbcff"
import script from "./InspectionMenu.vue?vue&type=script&lang=js"
export * from "./InspectionMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__